import React, { Component } from 'react'
import { View } from 'react-native'
export default class SafeView extends Component {
  render() {
    return <View {...this.props} style={[{ flex: 1 }, this.props.style]} />
  }
}
